/**
 * Tâche 1328 (Eric 2026-06-30) — Traduire HORS du contexte React.
 *
 * Réservé aux error boundaries. Ce sont des composants de classe, et surtout
 * ils s'affichent précisément quand l'arbre React a planté : y consommer un
 * contexte React reviendrait à faire dépendre le message d'erreur de ce qui
 * vient de casser, avec l'écran blanc au bout. On lit donc la langue
 * directement là où `LanguageContext` la range.
 *
 * Partout ailleurs, utiliser `useLang().tr` — la langue y est réactive, ce
 * qui n'est pas le cas ici (un boundary ne se re-rend pas sur un changement
 * de langue, et c'est sans conséquence : on quitte l'écran aussitôt).
 */
export const CLE_LANGUE = "knoria-lang";

export function langueCourante() {
  try {
    return localStorage.getItem(CLE_LANGUE) === "en" ? "en" : "fr";
  } catch {
    // Navigation privée stricte : le stockage peut lever. Le français est la
    // langue par défaut de Knoria, on s'y replie sans bruit.
    return "fr";
  }
}

export function trHorsContexte(fr, en) {
  return langueCourante() === "en" ? (en ?? fr) : fr;
}
